import './WorkflowButton.scss';

export type WorkFlowButtonProps = {
  count: string;
  title: 'Inspection' | 'Observation' | 'Incident';
  onClick: () => void;
};

export const WorkFlowButton: React.FC<WorkFlowButtonProps> = ({
  count,
  title,
  onClick,
}) => {
  return (
    <button
      className={`workflow-button ${title.toLowerCase()}-btn`}
      onClick={onClick}
    >
      <div className="count-container position-relative">
        <span className="count">{count}</span>
      </div>
      <span className="title">{title}</span>
    </button>
  );
};
